import { explicitMaybe } from '@execonline-inc/decoders';
import { structuredMaybeDecoder } from '@execonline-inc/structured-maybe';
import { alreadyTranslatedText } from '@execonline-inc/translations';
import { Decoder, array, dateISO, field, number, string, succeed } from 'jsonous';
import { resourceDecoder } from '../../../../../Resource/Decoders';
import { Resource } from '../../../../../Resource/Types';
import {
  offeringTypeDecoder,
  programFamilyShareUrlResourceDecoder,
  shareUrlResourceDecoder,
} from '../../../Decoders';
import {
  ShareableLink,
  ShareableLinkExperience,
  ShareableLinksCollection,
  ShareableLinksResource,
} from './Types';

const experienceDecoder: Decoder<ShareableLinkExperience> = succeed({})
  .assign('id', field('id', number))
  .assign('offeringType', field('offering_type', offeringTypeDecoder))
  .assign('schoolPartnerLogoUrl', field('school_partner_logo_url', explicitMaybe(string)))
  .assign('schoolPartnerName', field('school_partner_name', explicitMaybe(string)));

const experienceResourceDecoder: Decoder<Resource<ShareableLinkExperience>> =
  resourceDecoder(experienceDecoder);

const shareableLinkDecoder: Decoder<ShareableLink> = succeed({})
  .assign('name', field('name', alreadyTranslatedText))
  .assign('shareUrl', field('share_url', programFamilyShareUrlResourceDecoder))
  .assign('experience', field('experience', experienceResourceDecoder));

const shareableLinksCollectionDecoder: Decoder<ShareableLinksCollection> = succeed({})
  .assign('id', field('id', number))
  .assign('name', field('name', string))
  .assign('publishedAt', field('published_at', structuredMaybeDecoder(dateISO)))
  .assign('shareUrl', field('share_url', structuredMaybeDecoder(shareUrlResourceDecoder)))
  .assign(
    'programFamilyShareUrls',
    field('learning_collection_program_family_share_urls', array(shareableLinkDecoder)),
  )
  .assign('possibleShareUrlCount', field('possible_share_url_count', number))
  .assign('duplicateProgramDeepLinkCount', field('duplicate_program_deep_link_count', number))
  .assign('totalShareUrlCount', field('total_share_url_count', number))
  .assign('filteredShareUrlCount', field('filtered_share_url_count', number));

export const shareableLinksResourceDecoder: Decoder<ShareableLinksResource> = resourceDecoder(
  shareableLinksCollectionDecoder,
);
